
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.4 17.9l-4.8-4.8c2.4-3.1 2.2-7.6-.7-10.5C12.3 1 10.3.3 8.3.3s-4.1.8-5.7 2.3c-3.1 3.1-3.1 8.2 0 11.3 1.6 1.6 3.6 2.3 5.6 2.3 1.7 0 3.4-.5 4.8-1.6l4.8 4.7c.2.2.5.3.8.3s.6-.1.8-.3c.4-.3.4-1 0-1.4zM8.3 14.1c-1.6 0-3-.6-4.1-1.7-2.3-2.3-2.3-6 0-8.3C5.3 3 6.8 2.4 8.3 2.4c1.6 0 3 .6 4.1 1.7s1.7 2.6 1.7 4.1-.6 3-1.7 4.1a5.54 5.54 0 01-4.1 1.8z"}})])
          )
        }
      }
    